var chunkPrefetchChunkToChildrenMap = {"5476":[86545,30380,86545,63287],"48637":[24014,86337],"82503":[24014,86337]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
